import { AnyAction } from 'redux';
import { GET_LOCKER_LIST_REQUEST, GET_LOCKER_LIST_SUCCESS, GET_LOCKER_LIST_FAILURE } from '../constants/locker-list.constants';

const initialState = {
    loading: false,
    data: [],
    error: '',
};

const lockerListReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_LOCKER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_LOCKER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };
        case GET_LOCKER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};

export default lockerListReducer;
